import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../../services/authentication.service";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Storage } from "../../utilities/storage";
import { Toastr } from "../../plugins/toastr/toastr";
import { Helper } from "../../utilities/helpers";
import { CustomValidator } from "../../utilities/validator/custom-validator";
import { MessagingService } from "../../services/messaging.service";
import * as moment from "moment";

@Component({
  templateUrl: "login.component.html",
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading: boolean = false;
  submitted: boolean = false;
  error: any = "";
  currentUser: any;
  public date: any = new Date();
  public year: any;

  constructor(
    private formBuilder: FormBuilder,
    public authService: AuthenticationService,
    private router: Router,
    public storage: Storage,
    public toastr: Toastr,
    public messagingService: MessagingService // public helper: Helper
  ) {
    this.year = moment(this.date).format("YYYY");
    this.checkIfAlreadyLoggedIn();
  }

  checkIfAlreadyLoggedIn() {
    // check if already logged in.
    this.currentUser = this.storage.get("currentUser");
    if (this.currentUser) {
      switch (this.currentUser.status) {
        case 1:
          this.router.navigate(["confirm-details"]);
          break;
        case 2:
          this.router.navigate(["enrollment-form"]);
          break;
        case 3:
          this.router.navigate(["enrollment-submitted"]);
          break;
        case 4:
          this.router.navigate(["counsellor-assigned"]);
          break;
        case 5:
          this.router.navigate(["colleges"]);
          break;
        case 6:
          this.router.navigate(["mentor-assigned"]);
          break;
        case 7:
          this.router.navigate(["colleges"]);
          break;
        case 8:
          this.router.navigate(["colleges"]);
          break;
        case 9:
          this.router.navigate(["colleges"]);
          break;
        default:
          this.router.navigate(["pages/login"]);
          break;
      }
    }
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ["", [Validators.required, CustomValidator.email]],
      password: ["", Validators.required],
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  login() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      console.log("error");
      return;
    }

    this._startLoading();
    this.authService.login(this.loginForm.value).subscribe(
      (res) => {
        console.log(res);
        if (res.data.is_student) {
          if (res.data.token) {
            if (res.data.owner.student_detail_status < 3) {
              if (res.data.owner.student_detail_status === 1) {
                this.router.navigate(["confirm-details"]);
                return;
              } else if (res.data.owner.student_detail_status === 2) {
                this.router.navigate(["enrollment-form"]);
                return;
              }
            }
            this._initPushNotifications(res.data.id);
            switch (res.data.owner.status) {
              case 1:
                this.router.navigate(["confirm-details"]);
                break;
              case 2:
                this.router.navigate(["enrollment-form"]);
                break;
              case 3:
                this.router.navigate(["enrollment-submitted"]);
                break;
              case 4:
                // const res.data.owner.student_detail_status =
                //   res.data.owner.student_detail_status;
                // if (res.data.owner.student_detail_status < 3) {
                //   if (res.data.owner.student_detail_status === 1) {
                //     this.router.navigate(["confirm-details"]);
                //     return;
                //   } else if (res.data.owner.student_detail_status === 2) {
                //     this.router.navigate(["enrollment-form"]);
                //     return;
                //   }
                // }
                this.router.navigate(["counsellor-assigned"]);
                break;

              case 5:
                // if (res.data.owner.student_detail_status < 3) {
                //   if (res.data.owner.student_detail_status === 1) {
                //     this.router.navigate(["confirm-details"]);
                //     return;
                //   } else if (res.data.owner.student_detail_status === 2) {
                //     this.router.navigate(["enrollment-form"]);
                //     return;
                //   }
                // }

                this.router.navigate(["colleges"]);
                break;
              case 6:
                // if (res.data.owner.student_detail_status < 3) {
                //   if (res.data.owner.student_detail_status === 1) {
                //     this.router.navigate(["confirm-details"]);
                //     return;
                //   } else if (res.data.owner.student_detail_status === 2) {
                //     this.router.navigate(["enrollment-form"]);
                //     return;
                //   }
                // }
                this.router.navigate(["mentor-assigned"]);
                break;
              case 7:
                // if (res.data.owner.student_detail_status < 3) {
                //   if (res.data.owner.student_detail_status === 1) {
                //     this.router.navigate(["confirm-details"]);
                //     return;
                //   } else if (res.data.owner.student_detail_status === 2) {
                //     this.router.navigate(["enrollment-form"]);
                //     return;
                //   }
                // }
                this.router.navigate(["colleges"]);
                break;
              case 8:
                // if (res.data.owner.student_detail_status < 3) {
                //   if (res.data.owner.student_detail_status === 1) {
                //     this.router.navigate(["confirm-details"]);
                //     return;
                //   } else if (res.data.owner.student_detail_status === 2) {
                //     this.router.navigate(["enrollment-form"]);
                //     return;
                //   }
                // }
                this.router.navigate(["colleges"]);
                break;
              case 9:
                // if (res.data.owner.student_detail_status < 3) {
                //   if (res.data.owner.student_detail_status === 1) {
                //     this.router.navigate(["confirm-details"]);
                //     return;
                //   } else if (res.data.owner.student_detail_status === 2) {
                //     this.router.navigate(["enrollment-form"]);
                //     return;
                //   }
                // }
                this.router.navigate(["colleges"]);
                break;
              default:
                this.router.navigate(["pages/login"]);
                break;
            }
          }
        } else {
          this.toastr.showWarning(
            "You are not allowed to log in from this app"
          );
        }
      },
      (error) => {
        this._stopLoading();
      }
    );
  }

  _initPushNotifications(userId) {
    this.messagingService.requestPermission(userId);
    this.messagingService.receiveMessage();
  }

  ngOnDestroy() {}

  _startLoading() {
    this.loading = true;
  }

  _stopLoading() {
    this.loading = false;
  }
}
